module.exports = __webpack_public_path__ + "static/img/standard-5.b1d7404c.png";